<template>
  <div>
    <div class="fm-flex fm-rela">
      <div
        style="
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
        "
        @click="disabled ? false : (showPopover = true)"
      ></div>
      <el-input
        :value="value ? value.name : ''"
        placeholder="请选择客户"
        style="width: 400px"
        suffix-icon="el-icon-arrow-right"
        readonly
        :disabled="disabled"
      ></el-input>
    </div>
    <el-dialog
      title="选择客户"
      append-to-body
      modal-append-to-body
      width="1000px"
      close-on-click-modal
      close-on-press-escape
      :visible.sync="showPopover"
    >
      <el-form inline :model="searchData">
        <el-form-item>
          <el-input
            placeholder="姓名/身份证/联系方式/紧急联系人"
            clearable
            prefix-icon="el-icon-search"
            v-model="searchData.searchInputValue"
            style="width: 200px"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="所属渠道">
          <ChannelSelect
            v-model="searchData.channelIdList"
            frozenCanSelect
            multiple
            @change="changeAndSearch"
          ></ChannelSelect>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            size="mini"
            @click="changeAndSearch"
          >
            查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-refresh" size="mini" @click="resetAndSearch">
            重置
          </el-button>
        </el-form-item>
      </el-form>
      <el-form inline>
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-plus"
          @click="showEditDialog()"
          v-hasPermi="['customer:manage:add']"
        >
          新增
        </el-button>
        <el-button
          icon="el-icon-delete"
          size="mini"
          plain
          type="danger"
          @click="select()"
        >
          清除已选
        </el-button>
      </el-form>
      <el-table
        v-loading="searchLoading"
        :data="searchRes && searchRes.data ? searchRes.data : []"
        stripe
        ref="refsTable"
        @sort-change="sortChange"
        max-height="300px"
      >
        <el-table-column
          fixed="left"
          prop="channel.name"
          label="所属渠道"
          width="150"
          align="left"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          fixed="left"
          prop="name"
          label="姓名"
          width="200"
          align="left"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="idCardNo"
          label="身份证号"
          width="150"
          align="center"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="age"
          label="年龄"
          width="100"
          align="center"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="phoneNumber"
          label="联系方式"
          width="130"
          align="center"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="emergencyPhoneNumber"
          label="紧急联系人"
          width="130"
          align="center"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <p v-qstype="scope.row.emergencyPhoneNumber ? '' : 'warning'">
              {{ scope.row.emergencyPhoneNumber || "—" }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="家庭住址"
          min-width="150"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <p v-qstype="scope.row.address ? '' : 'warning'">
              {{ scope.row.address || "—" }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="150"
          align="center"
          header-align="center"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.stop="select(scope.row)"
              type="text"
              icon="el-icon-thumb"
            >
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="hideclose"
        v-if="searchRes && searchRes.pageInfo"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchRes.pageInfo.page"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="searchRes.pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchRes.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "QshpzyWebCustomerSelectDialog",
  props: {
    value: {
      type: Object,
      default() {
        return null;
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showPopover: {
      handler(newVal, val) {
        if (newVal) {
          this.search(true);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      showPopover: false,

      searchLoading: false,
      searchData: {
        searchInputValue: null,
        channelIdList: [],
        minAge: null,
        maxAge: null,
      },

      searchParam: {
        quickSearchInfoList: [
          {
            columns: [
              "name",
              "idCardNo",
              "phoneNumber",
              "emergencyPhoneNumber",
            ],
            quickSearchValue: null,
          },
        ],
        channelIdList: null,
        minAge: null,
        maxAge: null,
        pageInfo: {
          page: 1,
          pageSize: 20,
        },
        sortInfo: null,
      },
      searchRes: {},

      editInfo: null,
    };
  },

  mounted() {},

  methods: {
    select(item) {
      this.$emit("select", item);
      this.showPopover = false;
    },

    handleSizeChange(val) {
      this.searchParam.pageInfo.pageSize = val;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    handleCurrentChange(val) {
      this.searchParam.pageInfo.page = val;
      this.search(false, {
        showSuccessMessage: true,
      });
    },

    changeAndSearch() {
      this.searchParam.quickSearchInfoList[0].quickSearchValue =
        this.searchData.searchInputValue;
      this.searchParam.channelIdList = this.searchData.channelIdList;
      this.searchParam.minAge = this.searchData.minAge;
      this.searchParam.maxAge = this.searchData.maxAge;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    resetAndSearch() {
      this.searchData = this.$options.data().searchData;
      this.changeAndSearch();
    },
    sortChange(val) {
      this.searchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    async search(init, args) {
      this.searchLoading = true;
      if (init) {
        this.searchParam.pageInfo.page = 1;
      }
      let requestRes = await this.$api.customer_findByPageForSelect(
        this.searchParam,
        args
      );
      if (requestRes && requestRes.success) {
        this.searchRes = requestRes;
        this.searchRes.pageInfo = requestRes.pageInfo;
        this.$nextTick(() => {
          this.$refs.refsTable.doLayout();
        });
      }
      if (requestRes.pageCount == 0) {
        this.searchRes = null;
      }
      setTimeout(() => {
        this.searchLoading = false;
      }, 200);
    },
    async showEditDialog(id) {
      this.editInfo = {
        channelId: null,
        name: null,
        idCardNo: null,
        age: 0,
        phoneNumber: null,
        emergencyPhoneNumber: null,
        address: null,
        frozen: false,
      };
    },
    async edit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.editInfo.id
          ? await this.$api.customer_update(this.editInfo, {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "修改中...",
              },
            })
          : await this.$api.customer_addNew(this.editInfo, {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "新增中...",
              },
            });
        if (requestRes && requestRes.success) {
          this.editInfo = null;
          this.search();
        }
      });
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/CustomerSelectDialog.vue